export default coin => Math.floor(coin / 100)
